var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBestDeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 95.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fab707;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.14,95.49c.29.43-22.1-17.54-16.13-33.8C6.97,45.43,18.37,26.46,7.5,14.51c0,0,11.05,5.58,12.27,16.58,0,0,4.21-26.78,17.54-31.09,0,0-10.35,4.3-5.44,19.93,4.91,15.62,15.08,17.22,11.4,34.75,0,0,9.3-8.13,5.79-16.1,0,0,19.99,19.93-7.89,55.48,0,0,2.98-9.88-4.03-19.77-7.01-9.88-5.09-18.81-4.03-21.2,0,0-10.35,10.52-6.14,21.52,0,0-4.74-1.91-4.74-7.81,0,0-15.91,12.43-5.09,28.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestDeal);
export default __webpack_public_path__ + "static/media/best-deal.6f507dc856fb2cfa5300636d91cd20af.svg";
export { ForwardRef as ReactComponent };